import { render, staticRenderFns } from "./MyProductsTab.vue?vue&type=template&id=66f9ed8d&scoped=true"
import script from "./MyProductsTab.vue?vue&type=script&lang=js"
export * from "./MyProductsTab.vue?vue&type=script&lang=js"
import style0 from "./MyProductsTab.vue?vue&type=style&index=0&id=66f9ed8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f9ed8d",
  null
  
)

export default component.exports